
export default {
  data() {
    return {
      course: [
        {
          // 2024
          title: this.$t('modules.intro.course.year_12'),
          dire: 'left',
          img: require('@/assets/img/about/intro/course/course_0013.png'),
          des: [
            this.$t('modules.intro.course.2024_1'),
            // this.$t('modules.intro.course.2023_2'),
          ],
        },
        {
          // 2023
          title: this.$t('modules.intro.course.year_11'),
          dire: 'right',
          img: require('@/assets/img/about/intro/course/course_0012.png'),
          des: [
            // this.$t('modules.intro.course.2023_1'),
            this.$t('modules.intro.course.2023_2'),
          ],
        },
        {
          // 2023
          title: '',
          dire: 'right',
          img: require('@/assets/img/about/intro/course/course_0014.png'),
          des: [
            this.$t('modules.intro.course.2023_1'),
            // this.$t('modules.intro.course.2023_2'),
          ],
        },
        {
          // 2022
          title: this.$t('modules.intro.course.after'),
          dire: 'left',
          img: require('@/assets/img/about/intro/course/course_001.png'),
          des: [
            this.$t('modules.intro.course.2022_1'),
            this.$t('modules.intro.course.2022_2'),
          ],
        },
        {
          title: this.$t('modules.intro.course.year_1'),
          dire: 'right',
          img: require('@/assets/img/about/intro/course/course_002.png'),
          des: [this.$t('modules.intro.course.2021_1')],
        },
        {
          title: this.$t('modules.intro.course.year_2'),
          dire: 'left',
          img: require('@/assets/img/about/intro/course/course_003.png'),
          des: [this.$t('modules.intro.course.2019_1')],
        },
        {
          title: this.$t('modules.intro.course.year_3'),
          dire: 'right',
          img: require('@/assets/img/about/intro/course/course_004.png'),
          des: [
            this.$t('modules.intro.course.2017_1'),
            this.$t('modules.intro.course.2017_2'),
          ],
        },
        {
          title: this.$t('modules.intro.course.year_4'),
          dire: 'left',
          img: require('@/assets/img/about/intro/course/course_005.png'),
          des: [this.$t('modules.intro.course.2016_1')],
        },
        {
          title: this.$t('modules.intro.course.year_5'),
          dire: 'right',
          img: require('@/assets/img/about/intro/course/course_006.png'),
          des: [this.$t('modules.intro.course.2010_1')],
        },
        {
          title: this.$t('modules.intro.course.year_6'),
          dire: 'left',
          img: require('@/assets/img/about/intro/course/course_007.png'),
          des: [
            this.$t('modules.intro.course.2009_1'),
            this.$t('modules.intro.course.2009_2'),
          ],
        },
        {
          title: this.$t('modules.intro.course.year_7'),
          dire: 'right',
          img: require('@/assets/img/about/intro/course/course_008.png'),
          des: [this.$t('modules.intro.course.2005_1')],
        },
        {
          title: this.$t('modules.intro.course.year_8'),
          dire: 'left',
          img: require('@/assets/img/about/intro/course/course_009.png'),
          des: [this.$t('modules.intro.course.2002_1')],
        },
        {
          title: this.$t('modules.intro.course.year_9'),
          dire: 'right',
          img: require('@/assets/img/about/intro/course/course_0010.png'),
          des: [this.$t('modules.intro.course.1997_1')],
        },
        {
          title: this.$t('modules.intro.course.year_10'),
          dire: 'left',
          img: require('@/assets/img/about/intro/course/course_0011.png'),
          des: [this.$t('modules.intro.course.1993_1')],
        },
      ],
    }
  },
  head() {
    return {
      title: this.$t('modules.intro.menu.course') + this.$t('navs.suffixName'),
    }
  },
}
